import styled from 'styled-components';
import { colors, devices } from '../../../base/styled/variables.styled';
export const FaqCardContainer = styled.div.withConfig({
    shouldForwardProp: (prop) => !['inverse', '$inverse'].includes(prop),
}) `
  display: flex;
  flex-direction: column;
  align-items: start;
  padding: 0;
  border-bottom: 2px solid ${({ $inverse }) => $inverse ? colors.neutral200 : colors.neutral200};
  transition: background-color 0.3s ease;
  width: 100%;
`;
export const TagWrapper = styled.div `
  margin-bottom: 16px;

  @media ${devices.tablets} {
    margin-bottom: 20px;
    margin-right: 24px;
    min-width: 150px; 
  }

  @media ${devices.mobile} {
    margin-bottom: 16px;
    margin-right: 8px;
    min-width: 150px; 
  }
`;
export const LinkWrapper = styled.div `
  flex: 1;
  padding-bottom: 16px;
`;
//# sourceMappingURL=FaqCard.style.js.map